module.exports = __webpack_public_path__ + "static/media/cross-in-circle.416b3bcf.svg";